import {
  HEX_000000,
  HEX_212F41,
  HEX_253548,
  HEX_3B93EE,
  HEX_646A7E,
  HEX_ADB5C7,
  HEX_DCDFE6,
  HEX_FCFDFE,
} from '@tanium/colors';
import { getRgbString } from '@tanium/coreui-utils';
import { defineColor, defineShadow } from '@tanium/react-theme-definition';

export const ClickableHoverBackground = defineColor([HEX_FCFDFE, HEX_212F41]);
export const ClickableHoverBorder = defineColor([getRgbString(HEX_3B93EE, '40%'), HEX_253548]);
export const ClickableHoverShadow = defineShadow([
  `0 2px 9px 0 ${getRgbString(HEX_ADB5C7, '60%')}`,
  `0 2px 4px 0 ${getRgbString(HEX_000000, '19%')}`,
]);

export const LegendText = defineColor([HEX_646A7E, HEX_DCDFE6]);
